import { Feature, GeometryObject } from "geojson";
import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";
import PanelInfoTable, { PanelInfoTableProps } from "../shared/PanelInfoTable";

import geojson from "geojson";
import { observer } from "mobx-react-lite";
import { useLocaleContext } from "../contexts/LocaleContext";
import { useRootStore } from "../models/Root";
import { Div, Section } from "trunx";

const hasDescription = (
  feature: any
): feature is geojson.Feature<geojson.MultiPoint, { description: string }> => {
  return feature?.properties?.description !== undefined;
};

export interface LayerInfoPanelProps {
  feature: Feature<GeometryObject>;
}

const LayerInfoPanel = ({ feature }: LayerInfoPanelProps) => {
  const {
    lang,
    dict: {
      panel: { layers: dict },
    },
  } = useLocaleContext();

  const {
    layers: { clearSelectedFeature },
  } = useRootStore();

  if (hasDescription(feature)) {
    const { properties: description } = feature;
    return (
      <Div bulma="panel">
        <p className="panel-heading">
          {dict.title}
          <span style={{ float: "right" }} onClick={clearSelectedFeature}>
            &times;
          </span>
        </p>
        <iframe
          style={{ backgroundColor: "white" }}
          title="description"
          srcDoc={description.description}
        ></iframe>
      </Div>
    );
  } else {
    // No explicit description, just show all properties in a table
    const properties = (feature as any)?.properties || {
      incidentname: "Unknown",
    };
    const incidentName =
      properties.irwin_IncidentName ||
      properties.IncidentName ||
      properties.incidentname ||
      properties.poly_IncidentName ||
      properties.IncidentName ||
      properties.name;

    const humanize = (row: [string, any]): [string, string] => {
      let [k, v] = row;
      k = k.replace(/poly_/g, " ");
      k = k.replace(/attr_/g, " ");
      k = k.replace(/_dt/g, " ");
      k = k.replace(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2")

      const maybeDate = new Date(v);
      const isDate = !isNaN(maybeDate as any) && maybeDate.getFullYear() > 2000;
      const v_ = isDate ? maybeDate.toLocaleString(lang) : v && v.toString();
      return [k, v_];
    };

    const rows: PanelInfoTableProps["rows"] =
      Object.entries(properties).map(humanize);

    return (
      <Div bulma="panel">
        <Div bulma="panel-heading">
          <LeafletPanelHeading
            title={incidentName}
            close={clearSelectedFeature}
          />
        </Div>

        <LeafletPanelBody>
          <Section>
            <PanelInfoTable rows={rows} />
          </Section>
        </LeafletPanelBody>
      </Div>
    );
  }
};

export default observer(LayerInfoPanel);
